import LocalStorageToast from './LocalStorageToast.container'
export default LocalStorageToast
